import React, { useEffect } from "react";
import "./index.css"; // External CSS
import { useNavigate, useSearchParams } from "react-router-dom";
import { COOKIES_EXPIRY_TIME } from "../../constants";
import { useCookies } from "react-cookie";
import { AUTH, HOMEPAGE } from "../../constants/RoutingPath";

const RedirectingPage = () => {
    const hotelURL = process.env.REACT_APP_LOGIN_URL;
    const accessToken = process.env.REACT_APP_API_TOKEN
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const [cookies, setCookie, removeCookie] = useCookies([]);


    const handleSaveToken = (token) => {
        setCookie(accessToken, token, {
            maxAge: COOKIES_EXPIRY_TIME,
            path: "/",
        });
        navigate(HOMEPAGE);
    };

    useEffect(() => {
        const token = searchParams.get("token")
        if (token) {
            handleSaveToken(token)
        } else {
            navigate(AUTH)
        }
    }, [searchParams])


    return (
        <div className="redirect-container">
            <p className="redirect-text">🔄 Redirecting to TRP login...</p>
            <p className="redirect-subtext">Please wait...</p>
        </div>
    );
};

export default RedirectingPage;
